import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useAuth } from "../../../../context/AuthContext";
import { backend } from "../../../../backend";
import { logAxiosError } from "../../../../logging/error";
import WarningModal from "../../../../components/WarningModal/WarningModal";
import "./settings.css";
import { Helmet } from "react-helmet-async";
import PasswordSettings from "./PasswordSettings/PasswordSettings";
import UserSettings from "./UserSettings/UserSettings";
import RoundedButton from "../../../../components/Buttons/RoundedButton/RoundedButton";

function Settings() {
  const navigate = useNavigate();

  const [showWarningModal, setShowWarningModal] = useState(false);

  const auth = useAuth();

  const deleteAllAds = async () => {
    try {
      const { data } = await axios.delete(backend("/api/listings/delete/all"), {
        data: {
          token: localStorage.getItem("token"),
        },
      });
      if (data.status) {
        await deleteAccountHandler();
      }
    } catch (error) {
      logAxiosError(error);
    }
  };

  const deleteAccountHandler = async () => {
    try {
      const { data } = await axios.post(backend("/api/users/delete"), {
        token: localStorage.getItem("token"),
        first_name: auth.user.first_name,
        email: auth.user.email,
      });

      if (data.status) {
        auth.logout();
        navigate("/");
      }
    } catch (error) {
      logAxiosError(error);
      // TODO: notify user
      if (error.response?.status === 401) {
        // invalid JWT token -> log out and return to landing page
        auth.logout();
      }
    }
  };

  return (
    <>
      <Helmet>
        <title>Inställningar | Vakansa</title>
        <meta
          name="description"
          content="Hantera dina kontoinställningar: uppdatera personuppgifter, byt lösenord, logga ut eller avsluta ditt konto."
        />
        <link rel="canonical" href={backend("/mina-sidor/installningar")} />

        <meta property="og:image" content="/images/logo/meta-logo.jpg" />
        <meta
          property="og:title"
          content="Hantera dina inställningar på Vakansa"
        />
        <meta
          property="og:description"
          content="Hantera enkelt dina kontoinställningar på Vakansa: uppdatera dina personuppgifter, byt lösenord, logga ut eller avsluta ditt konto."
        />
        <meta name="robots" content="noindex" />
      </Helmet>
      <div className="settings-container">
        <div className="settings-form-container">
          <UserSettings />
          <PasswordSettings />
        </div>
        <div className="settings-btns">
          <RoundedButton
            color="green"
            label="Logga ut"
            onClick={() => auth.logout()}
          />

          <RoundedButton
            color="red"
            label="Avsluta konto"
            onClick={() => setShowWarningModal(true)}
          />
        </div>
      </div>
      {showWarningModal && (
        <WarningModal
          heading="Avsluta konto"
          text="Är du säker att du vill avsluta ditt konto hos Vakansa? Detta går inte att återställa och alla dina annonser kommer tas bort."
          setShowModal={setShowWarningModal}
          onConfirm={() => {
            deleteAllAds();
          }}
          confirmBtnText="Avsluta"
        />
      )}
    </>
  );
}

export default Settings;
